import { createFileRoute } from '@tanstack/react-router'

import { shiftDate, today } from '../lib/format'
import { historyQuery } from '../lib/queries'
import { Week } from '../screens/Week'

export const Route = createFileRoute('/week')({
  loader: ({ context }) => {
    const to = today()
    return context.queryClient.ensureQueryData(historyQuery(shiftDate(to, -6), to))
  },
  component: Week,
})
